import React, { Fragment, useContext, useEffect, useState } from 'react' ;


import axios from 'axios';
import { Link } from 'react-router-dom';
import TimeAgo from '../../TimeAgo/TimeAgo.jsx';
import { UserContext } from '../../../Context/UserContext.js';
import "./prescriptionDashboard.css"
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';











export default function PrescriptionDashboard() {
   const [prescription , setPrescription] = useState([])
   const{userToken} = useContext(UserContext) ;



   const header = {
      token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   };



   async function checkSeen (id){
      await axios.patch(`${process.env.REACT_APP_BASE_URL}/api/v1/prescription/${id}`  ,{} ,  {headers:header})
      .then(({data})=>{
         if(data.message === "success"){
            setPrescription(data.prescriptions)
            toast.success(data.message)         
         }
      })
      .catch((error)=>{
         toast.error(error.response?.data?.message)
      })
   }



      //& Get All test And Search On Test By Test Name :
      async function deletePrescription(id){
         Swal.fire({
            title: "Do you want to Delete the Prescription?",
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: "Delete",
            denyButtonText: `Don't Deleted`
            }).then(async (result) => {
            if (result.isConfirmed) {
               await axios.delete(`${process.env.REACT_APP_BASE_URL}/api/v1/prescription/${id}`  ,  {headers:header} )
               .then(({data})=>{
                  if(data.message === "success"){
                     setPrescription(data.prescriptions) ;
                     Swal.fire("Deleted!", "", "success") ;
                  }
               })
               .catch((error)=>{
                  toast.error(error.response?.data?.message)
               })
            } else if (result.isDenied) {
               Swal.fire("Changes are not delete", "", "info");
            }
         });
      }



   async function getPrescription () {
      try {
         const { data } = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/api/v1/prescription`, 
            { headers: header }
         );
      
         if (data.message === "success") {
            console.log(data.prescription);
            
            setPrescription(data.prescription);
            // toast.success(`${data.message} - Add Test in Cart`);
         } else {
            toast.error("Unexpected response from the server");
         }
      
      } catch (error) {
         toast.error(error.response?.data?.message || "Something went wrong");
      }
   }


   useEffect(() => {
      getPrescription()
   }, []) ;
   return (
      <Fragment>
         <div className='container-fluid PrescriptionDashboard-container'>
            <h4 className='text-center border-2 border-bottom py-2 fw-bold'>Prescription</h4>

            <div className='container'>
                  <div >
                     {prescription.length > 0 ? 
                        prescription.map((ele)=>
                           <div className='bg-body-secondary p-2 rounded-2 my-2'>
                              <div className='d-flex justify-content-between align-item-center'>
                                 <div>
                                    <p className='m-0'>Created By : {ele.createdBy?.name}</p>
                                    <p className='m-0'>Created At : {ele.createdAt}</p>
                                    <p className='m-0'><TimeAgo createdAt={ele.createdAt}/></p>
                                    <p className='m-0'>Phone : {ele.phone}</p>
                                 </div>
                                 <div className='image-container-admin'>
                                    <img src={ele.image} className='w-100' alt="imageCover" />
                                 </div>
                              </div>

                              <div dir='rtl' className='my-2  bg-body-tertiary rounded-2 p-2'>
                                 <h5>الرسالة: </h5>
                                 <p className=''>{ele.message}</p>
                              </div>

                              <div className='w-75  m-auto text-center d-flex justify-content-around align-item-center'>
                                 <Link to={ele.download_URL}><i className="fa-solid text-success fa-download btn "></i></Link>
                                 <span>{ele.is_seen ?  <i className="fa-solid fa-eye text-primary"></i>  :  <i className="fa-solid fa-eye-slash text-danger btn"  onClick={()=>{checkSeen(ele._id)}} ></i> }</span>
                                 <i className="fa-solid text-danger fa-trash-can btn" onClick={()=>{deletePrescription(ele._id)}}></i>
                              </div>
                           </div>
                        )
                        : 
                        ""
                     }
                  </div>
            </div>
         </div>
      </Fragment>
   )
}
